// WP-A · public Firebase web config. These values are safe for the browser
// (the apiKey is Firebase-restricted to identity/Firestore/Storage and meant to
// be public). Mirrors credentials/firebase-web-config.json, which is gitignored
// because it lives alongside real secrets; embedding the public config here is
// the standard Firebase pattern and keeps the build self-contained.
// Source of truth: credentials/firebase-web-config.json + credentials/manifest.json.

export const firebaseConfig = {
  apiKey: "AIzaSyBdFp1rZvzeiPLeJ9oF6BXG94bp5yQ5FG8",
  authDomain: "onebeachbot.firebaseapp.com",
  projectId: "onebeachbot",
  storageBucket: "onebeachbot.firebasestorage.app",
  messagingSenderId: "848110750941",
  appId: "1:848110750941:web:9c5cf79029604264a1df34",
  measurementId: "G-BM3WE3LPJW",
};

// The dedicated guest-ID bucket. NOTE (Q-A2): this bucket currently has uniform
// bucket-level access, which is incompatible with Firebase Storage security
// rules. Client uploads therefore target the default Firebase Storage bucket
// (firebaseConfig.storageBucket) under the guest-ids/ prefix, secured by
// storage.rules. WP-B/brain may relocate objects to this dedicated bucket. See
// HUMAN_INTERVENTION Q-A2.
export const GUEST_ID_BUCKET = "gs://onebeachbot-guest-ids";

// Product constants from Pricing!Config (02_DATA_MODEL §4). Hardcoded here as
// the client cannot read the Master/Pricing sheet; the values are policy, not
// runtime config. If they change, update here + Pricing!Config together.
export const MIN_NIGHTS = 6; // D19 — minimum direct-booking length
export const MAX_NIGHTS = 28; // D19 — maximum direct-booking length
// Gap-fill exception (session 66, Julie): a stay of exactly GAP_FILL_NIGHTS is
// allowed when it fills the WHOLE hole between two bookings (checks in on one
// booking's checkout day, checks out on the next one's check-in day) — an
// otherwise unsellable 5-night gap. Never shorter: "less than that I could end
// up with an island people party". Mirrored by the leads rule floor
// (firestore.rules) and the brain's re-check (Quote_isGapFill).
export const GAP_FILL_NIGHTS = 5;
export const MAX_GUESTS = 20; // arrival form cap (D14 bunk capacity)
// Booking horizon: guests may not pick dates further than 18 months out
// (Julie's pricing isn't set beyond that, and it matches VRBO's 18-month
// window + the cleaner schedule's CLEANER_GANTT_FUTURE_DAYS — one consistent
// timeframe everywhere). The availability mirror publishes busy ranges across
// the same horizon (_WINDOW_DAYS in the availability CF).
export const MAX_ADVANCE_DAYS = 548;

// payment_channel values offered on the public guest form. card has been a
// permanent member since the 2026-08-06 production cutover (session 46 — WP-F
// live; it rode a `?card=1` query-param gate during sandbox testing, sessions
// 41-45). venmo/zelle are internal only (02_DATA_MODEL §1) and never appear
// here (D-critical rule #5).
// Session 49 (user): the labels carry NO deposit framing — the old
// "($5,000 deposit)" vs "(card on file, no deposit)" labels steered everyone
// to card. The deposit/pre-authentication is mentioned once, neutrally, as
// part of the offer (the LeadForm hint + the quote email), and the default
// selection is check (LeadForm).
export const PAYMENT_CHANNELS = ["check", "wire", "card"];
export const PAYMENT_CHANNEL_LABELS = {
  check: "Check",
  wire: "Wire",
  card: "Credit Card",
};

// The one neutral deposit mention (session 49; session 54 truth fix) — shown
// under the LeadForm payment-method select and mirrored in the quote email.
// Every booking carries a $5,000 refundable damage deposit, whatever the
// rail; card payments carry Square's processing fee (the deposit itself
// returns in full, the fee never does). Never "$0" — the expectation must be
// set regardless of the method.
export const DEPOSIT_NOTE_TEXT =
  "Every booking carries a $5,000 refundable damage deposit, returned after your stay (check, wire, or card - card payments add Square's processing fee). Details ride with your rental agreement.";

export const CALLBACK_PREFS = ["call_me", "email_is_great"];
export const CALLBACK_LABELS = { call_me: "Call from Julie", email_is_great: "Email is great" };
export const AGES = ["18+", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"];

// Friendly, templateable note shown under the Wedding selector when a guest
// chooses "Yes". Editable copy (not code) — keep it warm + factual.
export const WEDDING_INFO_TEXT =
  "We love hosting weddings at our beautiful beachfront. Please note that due to the additional work involved, there's an additional charge for choosing One Beach Road as a wedding location due to the extended preparation and cleanup involved.";
